import zhLocale from "element-ui/lib/locale/lang/zh-CN";

export default {
  ...zhLocale,

  energyExchange: "兑换资源",
  Aboutus: "平台介绍",
  FAQ: "常见问题",
  Support: "在线客服",
  Switchlanguage: "切换语言",
  tips1: "转账次数购买",
  tips2: "简单方便 帮你省钱",
  tips3: "温馨提示：因为币价飞涨，能量池供应紧缺，购买时请注意余额！",
  tips4: "能量兑换 - 操作说明",
  tips5: "请使用去中心化钱包租赁能量。",
  tips6:
    "根据能量的租赁需求，系统会计算出兑换总量和需支付金额。仅支持TRX支付。",
  tips7: "转账完成后，平台将派发对应的能量到您的收款账户中。",
  tips8: "提倡按需租赁，用完再来租！每天不限次数！",
  tips9: "Energy Infinite 平台介绍",
  Economic: "经济",

  SAFE: "安全",
  EFFICIENT: "高效",

  tips10:
    "Energy Infinite 平台是波场生态中的能量兑换平台。我们的宗旨是为波场交易者降低能量消耗所需TRX费用。兑换流程简单快捷，价格优惠，24小时为您提供更安全且高效的能量兑换服务。",

  tips11: "解决 TRX 手续费过高问题",

  tips12: "快捷方便，只需转账即可兑换能量",
  tips13: "适用USDT、合约转账、部署合约等",
  tips14: "TRON 波场用户必备省钱专家",
  tips15: "FAQ 常见问题",
  tips16: "如何购买次数",

  tips17:
    "请在本页站头部点击兑换资源并填写购买信息，然后根据提示向平台账户转入对应的TRX即可。",
  tips18: "支付成功后，能量什么时候到账？",
  tips19:
    "付款完成后，正常情况下能量会在6秒内到账。由于广播延迟等原因，极少数情况，会存在30到60秒的延迟。若没收到能量，请联系客服处理。",
  tips20: "同一接收地址同时可以几笔订单？",
  tips21: "同一地址也可以多笔购买，不限制使用次数。",
  tips22: "订单可以撤回吗？",

  tips23: "当您向平台账户支付费用后，订单不支持撤回。",
  Paymentaddress: "付款地址",
  Receivingaddress: "接收地址",
  Keywords: "付款地址 / 收款地址 / 交易哈希",
  Rentingenergy: "租用能量",
  RentingBandwidth: "租用带宽",
  resourceType: "资源类型",
  Price: "价格",
  pleaseSelect: "请选择",
  Createorder: "创建订单",
  cancel: "取消",
  OnlineService: "在线客服",
  tips24: "有碰到任何问题，欢迎咨询在线客服",
  tips25: "点击复制",
  pleaseInput: "请输入",
  tips26: "请输入大于0的有效数字",
  tips27: "订单创建失败，请稍后再试！",
  day: "天",
  minute: "分",
  hour: "时",
  unitprice: "单价",
  confirm: "确定",
  prompt: "提示",
  replicatingSuccess: "复制成功！",
  tips28: "当前能量池可购买余额",
  tips28Bandwidth: "当前带宽池可购买余额",
  tips29: "平台收款地址",
  tips30: "查看收款二维码",
  QRcode: "平台收款二维码",
  save: "保存",
  tips31: "最新接收记录",
  rechargeHistory: "充值记录",
  recharge: "充值",
  confirmRecharge:'确认充值',

  rechargeBalance: "充值金额",
  Users: "接收地址",
  ExchangeType: "兑换类型",
  Amount: "接收数量",
  OrderState: "订单状态",
  searchKey: "请输入搜索关键字",
  search: "查询",
  tips32: "接收记录查询失败，请稍后再试！",
  500: "系统异常",
  400: "参数有误",
  10001: "用户名或密码错误",
  10002: "请先登录",
  20001: "地址已经添加,请勿重复添加",
  20002: "请先进行能量租赁授权",
  20003: "资源不足，请稍后重试",
  20004: "错误的地址",
  20005: "金主不存在",
  20006: "金主权重设置有误",
  20007: "订单不可操作",
  20008: "订单支付不存在",
  20009: "金主钱包能量/带宽不足",
  20010: "二维码生成失败",
  20011: "余额不足",
  20012: "企业未找到",
  20013: "请输入付款地址",

  20014: "密钥有误",
  20015: "不能重置管理员密码",
  20016: "不能重置管理员状态",
  20017: "代理能量失败",
  20018: "地址簿数量已达到上限",
  20019: "地址不能重复添加",
  20020: "重复的数据",
  20021: "用户不存在",
  20022: "金主绑定达到上限",
  20023: "地址监控达到上限",
  10017: "请输入包含数字、字母长度6到16位的密码",
  10018: "付款地址不匹配",
  10019: "付款金额不匹配",
  10020: "缺少企业支付id",
  10021: "交易重复绑定",
  10024: "能量池余额不足请稍后再试",

  90001: "非常抱歉,服务维护中,请稍后重试",
  10022:'用户名已存在',

  tips: "提示",
  Copyaddress: "复制地址",
  tips33: "Energy Infinite 便捷省钱服务平台",
  tips34: "65000能量可以转一笔账。",
  tips34Bandwidth: "280带宽可以转一笔账。",
  tips35: "请输入整数",
  tips36: "能量派发中，请稍后......",
  tips37:'两次密码不一致',
  tips38:'密码修改成功，请重新登录',

  referralCode: "推荐码",
  EnterprisePayKey: "企业支付秘钥",
  EnterprisePayId: "企业支付Id",
  rent: "租",
  only: "只需",
  energy: "能量",
  bandwidth: "带宽",
  currentPriceEffective: "当前生效价",
  timeRangeSetting: "时段设置",
  Transactioncount: "转账笔数",
  Completepayment: "完成支付",
  Enterpriseuser: "企业用户",
  Ordinaryuser: "普通用户",
  TxHash: "交易hash",
  PromitBalance: "您当前的余额为",
  AccountBalance: "账户余额",
  login:'登录',
  userName:'用户名',
  password:'密码',
  register:'去注册',
  signUp:'注册',
  confirmPassword:'确认密码',
  orderNo: '订单号',
  createTime: '创建时间',
  balanceRecharge: '余额充值',
  logOut:'退出登录',
  editPw:'修改密码',
  oldPw:'旧密码',
  newPw:'新密码',
  PersonalInformation:'用户信息',
  ProxyTxId: "代理txId",
  noEnterprisePrice: "暂无企业价格，请联系客服添加",
  addressBook: '地址簿',
  address: '地址',
  operations: '操作',
  delete: '删除',
  add: '添加',
  pleaseInputAddress: '请输入地址',
  addSuccess: '添加成功',
  deleteSuccess: '删除成功',
  confirmDelete: '确认删除该地址吗？',
  monitorAddress: '监控地址',
  monitorAddressBook: '监控地址簿',
  setMonitorInterval: '设置监听间隔',
  monitorInterval: '监听间隔',
  oneHour: '1小时',
  threeHours: '3小时',
  sixHours: '6小时',
  twelveHours: '12小时',
  twentyFourHours: '24小时',
  platformReceiveAddress: '平台收款地址',
  noExclusiveAddress: '未配置专属地址',
  noExclusiveAddressTip: '您未开通充值专属地址功能，请联系客服，或使用下方功能创建一般充值订单',
  hasExclusiveAddress: '已配置专属地址',
  yourExclusiveAddress: '您的专属充值地址为',
  exclusiveAddressTip: '您可以直接转入TRX，并稍等10秒钟后完成自动上分',
  canStillUseGeneral: '您仍可以使用下方功能创建一般充值订单',
  generalRechargeNotice: '一般充值订单须提交付款地址及充值金额进行匹配，若输入错误，请联系客服核实，手动上分',
  notice: '注意',
  refresh: '刷新',
  refreshSuccess: '刷新成功',
  refreshFailed: '刷新失败',
  copy: '复制',
  serverError: '服务器异常，请稍后重试',
  energyThreshold: '能量阈值',
  pleaseInputEnergyThreshold: '请输入能量阈值',
  energyThresholdMustBeNumber: '能量阈值必须为数字',
  energyThresholdRange: '能量阈值范围0-100000000',
  monitorThreshold: '监控阈值',
  pleaseInputMonitorThreshold: '请输入监控阈值',
  monitorThresholdMustBeNumber: '监控阈值必须为数字',
  monitorThresholdRange: '监控阈值范围0-100000000',
  pleaseInputBandwidthThreshold: '请输入带宽阈值',
  rentalAmount: '租用数额',
  pleaseInputRentalAmount: '请输入租用数额',
  rentalAmountMustBeNumber: '租用数额必须为数字',
  rentalAmountRange: '租用数额范围100-1000000000',
  pleaseInputBandwidthAmount: '请输入带宽租用量',
  pleaseInputEnergyAmount: '请输入能量租用量',
  monitorPriceTypeMismatch: '所选价格与资源类型不匹配',
  balanceNotifyThreshold: "余额不足提醒阈值",
  balanceNotifyInterval: "提醒时间间隔",
  seconds: "秒",
  valueRangeError: "数值必须在0-10000000之间",
  saveSuccess: "保存成功",
  saveFailed: "保存失败",
  never: "从不",
  tenMinutes: "10分钟",
  thirtyMinutes: "30分钟",
  twelveHours: "12小时",
  oneDay: "1天",
  sevenDays: "7天",
  bandwidthMinTip: "单次带宽租赁不能低于{amount}",
  bandwidthPresetMin: "5,000",
  bandwidthPreset20: "5,600(20笔)",
  bandwidthPreset40: "11,200(40笔)",
  bandwidthAmountTooSmall: "带宽下单量不能低于{amount}",
  bandwidthAmountStepTip: "建议按 280 带宽/笔 的整数倍输入(20笔=5,600, 40笔=11,200)"
};



// WEBPACK FOOTER //
// ./src/i18n/zh.js